module.exports = __webpack_public_path__ + "img/iosevka-dark.4e9a2b78.png";